import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipProps } from '@mui/material';

import { ContentType } from '@models/Content';

import { Icon, IconProps } from '../Icon';

import { ContentTypeIconMap } from './utils';

export type ContentIconProps = Omit<IconProps, 'name'> & {
  contentType: ContentType;
  hideTooltip?: boolean;
  TooltipProps?: Partial<Omit<TooltipProps, 'children'>>;
};

export const ContentIcon: FC<ContentIconProps> = ({
  contentType,
  hideTooltip,
  TooltipProps: tooltipProps,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={hideTooltip ? undefined : t(`contentType.${contentType}`)} {...tooltipProps}>
      <Icon name={ContentTypeIconMap[contentType]} {...rest} />
    </Tooltip>
  );
};
